import { useContext } from 'react';

import { OnlineBookingStateContext } from './context';

export const useOnlineBookingReducer = () => useContext(OnlineBookingStateContext);
